import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce04dadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"border-top":"0"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("近一周互动热门关键词 ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commontips" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "chart-block"
}
const _hoisted_5 = {
  key: 0,
  class: "chartsul"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "widthspan" }
const _hoisted_9 = { class: "itemcount" }
const _hoisted_10 = {
  key: 1,
  class: "empty"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "commontips" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chartslist", _ctx.theme])
  }, [
    (_ctx.titleInfo.type !== 'gn' && _ctx.titleInfo.type !== 'gp')
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("span", null, [
              _hoisted_2,
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                title: "显示全市场近期互动问答中出现频率高的关键词",
                overlayClassName: "tooltipstyle",
                "arrow-point-at-center": "",
                getPopupContainer: _ctx.getPopupContainer
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["getPopupContainer"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.titleInfo.type !== 'gn' && _ctx.titleInfo.type !== 'gp')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          ((_ctx.chartsData||[]).length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chartsData, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.Inst,
                    class: _normalizeClass({'active': item.Name === _ctx.currentName}),
                    onClick: ($event: any) => (_ctx.handclick(item))
                  }, [
                    _createElementVNode("span", {
                      class: "itemname",
                      title: _ctx.Name,
                      onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getName && _ctx.getName(...args))),
                      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelName && _ctx.cancelName(...args)))
                    }, _toDisplayString(item.Name), 41, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", {
                        class: "red-color",
                        style: _normalizeStyle({width: (item.Num / _ctx.maxdata)*100+'%'})
                      }, null, 4)
                    ]),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.Num), 1)
                  ], 10, _hoisted_6))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_Nodata, {
                  class: "cardwrap",
                  mode: "vertical",
                  customdesc: '暂无数据'
                })
              ]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h3", {
      class: _normalizeClass([{'bottom-h':_ctx.bottomTit.showPop},{'border-top-h3': _ctx.titleInfo.type !== 'gn' && _ctx.titleInfo.type !== 'gp'}])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.bottomTit.text) + " ", 1),
          (_ctx.bottomTit.showPop)
            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                key: 0,
                placement: "topLeft",
                overlayClassName: "tooltipstyle",
                title: "显示问答中出现该关键词的所有个股",
                "arrow-point-at-center": "",
                getPopupContainer: _ctx.getPopupContainer
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["getPopupContainer"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({'top10table': _ctx.titleInfo.type === 'all'})
    }, [
      (_ctx.titleInfo.type==='gp')
        ? (_openBlock(), _createBlock(_component_Table, {
            class: "gn-table",
            ref: "gntable",
            loading: _ctx.loading1,
            key: _ctx.key2,
            style: {"height":"calc(50vh - 45px)"},
            data: _ctx.tableDataGN,
            columns: _ctx.columnsGN,
            theme: _ctx.theme,
            scroll: { y: 'calc(50vh - 80px)', x: '100%' },
            bordered: false,
            onOnChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChange($event,'gn'))),
            onClickRow: _ctx.clickRow,
            onDbClickRow: _ctx.dbClickRow
          }, null, 8, ["loading", "data", "columns", "theme", "scroll", "onClickRow", "onDbClickRow"]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_component_Table, {
        class: _normalizeClass(["gp-table", {'bottomloading': _ctx.PageID !== 1 && _ctx.loading2, 'tabledatawrap': !_ctx.allloaded }]),
        ref: "gptable",
        loading: _ctx.loading2,
        key: _ctx.key1,
        data: _ctx.tableData,
        style: _normalizeStyle({width:'100%',height:_ctx.gpTableH}),
        columns: _ctx.columns,
        theme: _ctx.theme,
        scroll: { y: _ctx.gpTableScrollH, x: '100%' },
        emptyText: {emptyText: '暂无数据'},
        bordered: false,
        onOnChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChange($event,'gp'))),
        onDbClickRow: _ctx.dbClickRow
      }, null, 8, ["class", "loading", "data", "style", "columns", "theme", "scroll", "onDbClickRow"]))
    ], 2)
  ], 2))
}